import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import {
  setupWaveform,
  setupCircularPlayer,
} from "/WebInterface/new-ui/modules/web-components/audio-player/players.js";

// Base class for audio players
class BaseAudio extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.renderSkeleton();
  }

  renderSkeleton() {
    this.shadowRoot.innerHTML = `
      <div id="player-container" class="skeleton skeleton-rect" style="--rect-h: 100%; --c-w: 100%; --c-p: 0%; --lines: 0; --bg: var(--bg-skeleton);"></div>
    `;
  }

  connectedCallback() {
    const src = this.getAttribute("src");
    const autonext =
      this.getAttribute("autonext") === "true" ||
      this.getAttribute("dir") === "true";
    const playerContainer = this.shadowRoot.querySelector("#player-container");

    this.setupPlayer(playerContainer, src, autonext);

    playerContainer.classList.remove("skeleton", "skeleton-rect");
    this.shadowRoot.adoptedStyleSheets = [this.responsiveStyles()];
  }

  setupPlayer(playerContainer, src, autonext) {
    // To be implemented by subclasses
  }

  responsiveStyles() {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(`
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }
      #player-container {
        width: 100%;
        height: 100%;
      }
    `);
    return sheet;
  }
}

// Waveform audio player
class WAudio extends BaseAudio {
  setupPlayer(playerContainer, src, autonext) {
    const { waveSurfer } = setupWaveform(playerContainer, src, {
      height: this.getAttribute("height") || 25,
      autonext,
    });
    this.player = waveSurfer;
  }
}

// Circular audio player
class WAudioCircular extends BaseAudio {
  setupPlayer(playerContainer, src, autonext) {
    const { audio } = setupCircularPlayer(playerContainer, src, { autonext });
    this.player = audio;
  }
}

// Define the custom elements
window.customElements.define("w-audio", WAudio);
window.customElements.define("w-audio-c", WAudioCircular);
